<template>
    <div class="lg:flex container mx-auto py-4 lg:space-x-4 px-2 md:px-0">
        <jet-form-main @submitted="postCreate" class="lg:w-2/3">
            <template #title>
            </template>

            <template #description>
            </template>
            
            <template #form>
                <div class="w-full mt-4">
                    <img :src="showImage" alt="post title" class="w-full h-40 object-cover mb-4 mx-auto" v-if="showImage">
                        <!-- Image -->
                    <file-input v-model="form.image" :error="form.errors.image" class="w-full" type="file" accept="image/*" label="Imagem" @change="getImage" />
                     <jet-input-error :message="form.errors.image" />
                </div>
                <!-- Title -->
                <div class="mt-4">
                    <jet-label for="title" value="Título" class="font-bold" />
                    <jet-input type="text" v-model="form.title" class="w-full"/>
                    <jet-input-error :message="form.errors.title" />
                </div>

                <div class="mt-4">
                    <jet-label for="body" value="Corpo" class="font-bold" />

                    <vue-editor v-model="form.body" />

                    <!-- <text-area-input v-model="form.body" rows="10" class="w-full"></text-area-input> -->
                    <jet-input-error :message="form.errors.body" class="mt-2" />
                </div>

                 <div class="mt-4">
                    <jet-label for="excerto" value="Excerto" class="font-bold" />

                    <text-area-input v-model="form.excerto" rows="4" class="w-full"></text-area-input>
                    <jet-input-error :message="form.errors.excerto" class="mt-2" />
                </div>
            </template>
        </jet-form-main>

        <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md mt-1 relative h-full lg:flex-1">

            <div class="flex items-center space-x-2">
                <label for="checked-toggle" class="inline-flex relative items-center cursor-pointer">
                    <jet-checkbox v-model="form.is_published" :checked="form.is_published == 1 ? true : false" id="checked-toggle" class="sr-only peer" />
                    <div class="w-11 h-6 bg-gray-100 rounded-full peer peer-focus:ring-4 peer-focus:ring-transparent peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-violet-500"></div>
                    <span class="ml-3 text-sm font-medium text-violet-500 uppercase" v-if="form.is_published == 1">Público</span>
                    <span class="ml-3 text-sm font-medium text-gray-400 uppercase" v-else>Rascunho</span>
                </label>
            </div>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="postUpdate" v-if="post">Atualizar</jet-button>
            
            
            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="postCreate" v-else>Criar</jet-button>

            <div class="flex justify-between mt-4">
                <jet-button @click.prevent="backToPosts()" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-violet-500 px-0"><icon name="back" />Voltar</jet-button>

                <jet-button v-if="post" @click.prevent="removePost(post)" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-amber-600 px-0"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
            </div>

        </div>
    </div>
</template>

<style>
    .ql-toolbar.ql-snow {
        border-radius: 0.375rem 0.375rem 0 0;
    }
    .ql-container.ql-snow {
        border-radius: 0 0 0.375rem 0.375rem;
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import Icon from '@/Jetstream/Icon'
    import FileInput from '@/Components/FileInput.vue'
    import { VueEditor, Quill } from "vue3-editor";

    export default defineComponent({
        components: {
            Head,
            Link,
            JetInput,
            TextAreaInput,
            JetLabel,
            JetActionMessage,
            JetButton,
            JetFormMain,
            JetInputError,
            JetModal,
            JetCheckbox,
            JetDialogModal,
            JetSecondaryButton,
            Icon,
            VueEditor,
            FileInput
        },
        layout: BackLayout,
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            categories: Array,
            post: Object,
            body: String
        },
        data() {
            return {
                imagePreview: null,
                showCatModal: false,
                form: this.$inertia.form({
                    title: '',
                    body: '',
                    category_id: '',
                    is_published: false,
                    image: null,
                    excerto: ''
                })
            }
        },
        computed: {
            showImage() {
                if(this.imagePreview != null) {
                    return this.imagePreview
                } else if(this.post && this.post.image) {
                    return '/storage/posts/' + this.post.image
                } else {
                    return false
                }
            }
        },
        created() {
            if(this.post) {
                this.form.title = this.post.title
                this.form.body = this.post.body
                this.form.category_id = this.post.category_id
                this.form.is_published = this.post.is_published
                this.form.excerto = this.post.excerto
            }
        },
        methods: {
            postCreate() {
                this.form.post(route('store.post'), {
                    errorBag: 'postCreate',
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                    onError: () => {
                    }
                })
            },
            postUpdate() {
                this.form.post(route('update.post', this.post ), {
                    method: 'PUT',
                    errorBag: 'postUpdate',
                    preserveScroll: true
                })
            },
            removePost(post) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.post', post));
                }
            },
            backToPosts() {
                this.$inertia.get(route('posts.index'))
            },
            inputBody(e) {
                this.form.body = e
            },
            getImage(event) {
                this.form.image = event.target.files[0]
                this.imagePreview = URL.createObjectURL(this.form.image)
            }
        },
    })
</script>